import {Component, Inject, OnInit} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';


import {LoginHelper, Role} from '../../helpers';

import {MAT_DIALOG_DATA, MatDialog, MatDialogRef} from '@angular/material/dialog';

import {
  AlertService,
  AuthenticationService,
  ClientProfileService,
  ComplianceAreaService,
  ProjectService,
  UserService,
} from '../../_services/index';
import {ClientITProfile, ComplianceArea, Project, User} from "../../_models";
import {ListMessageComponent} from "../listMessage";
import {MatDialogConfig} from "@angular/material/dialog";
import { Constants } from '../../helpers/constants';

@Component({
    standalone: false,
  selector: 'import-ssp-component',
  templateUrl: 'importSsp.component.html'
})

export class ImportSspComponent implements OnInit {

  itProfiles: ClientITProfile[];
  itProfileId = 0;

  allProjects: Project[];
  projects: Project[] = [];
  projectId = 0;

  complianceAreas: ComplianceArea[];
  complianceAreaIds: number[] = [];
  file: any;

  projectName = '';
  profileName = '';
  additionalUserId = 0;

  additionalUsers: User[] = [];
  constants = Constants;

  constructor(
    public dialogRef: MatDialogRef<ImportSspComponent>,
    public projectService: ProjectService,
    @Inject(MAT_DIALOG_DATA) public data: any,
    public router: Router,
    public clientProfileService: ClientProfileService,
    public route: ActivatedRoute,
    public alertService: AlertService,
    public dialog: MatDialog,
    public userService: UserService,
    public complianceAreaService: ComplianceAreaService,
    public authenticationService: AuthenticationService) {
  }

  ngOnInit() {
    this.clientProfileService.getClientProfiles(LoginHelper.getTenantName())
      .subscribe((clientITProfiles: ClientITProfile[]) => {
        this.itProfiles = clientITProfiles;
      });
    const currentUser = JSON.parse(sessionStorage.getItem('currentUser'));
    // tslint:disable-next-line:no-bitwise
    const rolesFilter = (currentUser.Role & (Role.PrimaryAdvisorLead | Role.PlatformSupport | Role.AdvisorLead | Role.AdvisorStaff)) == 0 ? (Role.PrimaryManager | Role.Manager | Role.User) : (Role.PrimaryAdvisorLead | Role.AdvisorLead | Role.AdvisorStaff);
    this.projectService.getAllShortWithComplianceAreas().subscribe(p => this.allProjects = p);
    this.userService.getAllShort().subscribe(u => this.additionalUsers = u.filter(u => (u.role & rolesFilter) != 0));
    this.complianceAreaService.getComplianceAreas().subscribe(s => this.complianceAreas = s);
  }

  import(): void {
    this.projectService.uploadSsp(this.projectId, this.itProfileId, this.complianceAreaIds, this.projectName, this.profileName, this.file, this.additionalUserId).subscribe(data => {
        if (data.error) {
          this.alertService.error(data.error);
        } else {
          if (data.length) {
            let config: MatDialogConfig = {
              panelClass: 'custom-overlay-pane-class',
              width: 'auto',
              height: '90%',
              data: {
                items: data,
                title: "SSP Import"
              }
            };
            this.dialog.open(ListMessageComponent, config);
          }
          this.dialogRef.close(true);
        }
      },
      error => {
        const errorMessage = 'Error during upload of SSP';
        this.alertService.error(errorMessage);
      });
  }

  selectFile(event) {
    this.file = event.target.files[0];
  }

  onClose(): void {
    this.dialogRef.close();
  }

  updateProjects() {
    this.projects = this.allProjects.filter(p => this.complianceAreaIds.find(i => p.complianceAreaIds.indexOf(i) >= 0));
  }
}
